const api = {
  Auth: "/auth/",
  User: "/user/",
  Teacher: "/teacher/",
  Log: "/log/",
  Master: "/master/",
};
export default api;
